export default __webpack_public_path__ + "static/media/eng.17dcf9cb.png";